export function isBlogSection(pathname) {
  if (pathname.indexOf('/blog') > -1) {
    return true;
  }
  return false;
}

export function isHelpCenterSection(pathname) {
  if (pathname.indexOf('/help') > -1) {
    return true;
  }
  return false;
}

export function isAuthorSection(pathname) {
  if (pathname.indexOf('/author') > -1) {
    return true;
  }
  return false;
}
